import Vue from 'vue'
import Request from '@/prototypes/request/request'

Vue.prototype.$request = new Request();
